"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.Plus = function () {
    return (React.createElement("svg", { fill: "#F27A1A", xmlns: "http://www.w3.org/2000/svg", width: "9", height: "9", viewBox: "0 0 9 9" },
        React.createElement("path", { d: "M4.434.004c-.28.032-.497.27-.497.558v3.375H.563C.252 3.938 0 4.19 0 4.5l.004.066c.032.28.27.497.558.497l3.375-.002v3.377c0 .31.252.562.563.562l.066-.004c.28-.032.497-.27.497-.559V5.063h3.375c.31 0 .562-.252.562-.563l-.004-.066c-.032-.28-.27-.497-.559-.497H5.063V.563C5.063.252 4.81 0 4.5 0l-.066.004z" })));
};
